import { useMemo } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Select } from '@factorialco/f0-react'
import { WorkspacesSelectorDocument, WorkspacesSelectorQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface Location {
  id: string
  name: string
}

interface LocationSelectorProps {
  value?: Location | null
  onSelect: (location: Location | null) => void
  label?: string
  emptyLabel?: string
  mandatory?: boolean
  disabled?: boolean
  error?: boolean
}

export const LocationSelector = ({
  value,
  onSelect,
  label,
  emptyLabel,
  mandatory = false,
  disabled = false,
  error = false,
}: LocationSelectorProps) => {
  const { data: locationsData } = useQuery<WorkspacesSelectorQuery, Record<string, never>>(
    WorkspacesSelectorDocument
  )

  const options = useMemo(
    () =>
      (locationsData?.spaceControl?.workSpacesConnection?.nodes || []).map(
        (node: WorkspacesSelectorQuery['spaceControl']['workSpacesConnection']['nodes'][0]) => ({
          label: node?.name || '',
          value: String(node?.id || ''),
          avatar: {
            type: 'team' as const,
            name: node?.name || '',
            src: '',
          },
        })
      ),
    [locationsData]
  )

  const handleChange = (locationId: string) => {
    const location = locationsData?.spaceControl?.workSpacesConnection?.nodes?.find(
      (node: WorkspacesSelectorQuery['spaceControl']['workSpacesConnection']['nodes'][0]) =>
        String(node?.id) === locationId
    )
    onSelect(
      location
        ? {
            id: String(location.id),
            name: location.name || '',
          }
        : null
    )
  }

  return (
    <Box gap="s8">
      <F0Select
        label={label}
        value={value?.id}
        onChange={handleChange}
        options={options}
        placeholder={emptyLabel}
        size="md"
        searchable
        disabled={disabled}
        error={error}
        required={mandatory}
      />
    </Box>
  )
}
